import ApiService from '../../../shared/services/api-service';
import commonActionCreators from '../../../shared/store/common/action-creators';
import trainingProgramsCommitTypes from './commit-types';
import notificationsActionsCreator from '../notifications/action-creators';

const trainingProgramsActionCreators = {
  activateTrainingProgram(trainingProgramGuid) {
    return async (dispatch) => {
      dispatch(this.setIsLoading('activateTrainingProgram'));
      const data = await ApiService.post(`/api/v1/training-programs/${trainingProgramGuid}/activate`)
        .then(response => response.data)
        .catch((error) => {
          Promise.resolve();
          dispatch(commonActionCreators.handleApiError(error));
        });
      dispatch(this.setIsLoading('activateTrainingProgram'));
      if (data) {
        dispatch(this.activateTrainingProgramSuccess(data));
      }
      return Promise.resolve(data.data.guid);
    };
  },
  activateTrainingProgramSuccess(activatedTrainingProgramResponse) {
    return async (dispatch) => {
      dispatch(this.replaceTrainingPrograms(activatedTrainingProgramResponse.data));
      dispatch(notificationsActionsCreator.addSavedSuccessfully('Training program activated'))
    };
  },
  closeEditTP() {
    return {
      isEditingTP: false,
      type: trainingProgramsCommitTypes.SET_IS_EDITING_TP,
    };
  },
  editTP() {
    return {
      isEditingTP: true,
      type: trainingProgramsCommitTypes.SET_IS_EDITING_TP,
    };
  },
  addNewPhase() {
    return {
      isAddingNewPhase: true,
      type: trainingProgramsCommitTypes.SET_IS_ADDING_NEW_PHASE
    }
  },
  closeAddNewPhase() {
    return {
      isAddingNewPhase: false,
      type: trainingProgramsCommitTypes.SET_IS_ADDING_NEW_PHASE
    }
  },
  fetchTrainingPrograms() {
    return async (dispatch) => {
      dispatch(this.setIsLoading('fetchTrainingPrograms'));
      const data = await ApiService.get('/api/v1/training-programs')
        .then(response => response.data)
        .catch((error) => {
          Promise.resolve();
          dispatch(commonActionCreators.handleApiError(error));
        });
      dispatch(this.setIsLoading('fetchTrainingPrograms'));
      if (data) {
        dispatch(this.fetchTrainingProgramsSuccess(data));
      }
      return Promise.resolve();
    };
  },
  fetchTrainingProgramsSuccess(usersResponse) {
    return async (dispatch) => {
      dispatch(this.pushTrainingPrograms(usersResponse.data));
    };
  },
  pushTrainingProgram(trainingProgram) {
    return {
      trainingProgram,
      type: trainingProgramsCommitTypes.PUSH_TP,
    };
  },
  pushTrainingPrograms(list) {
    return {
      list,
      type: trainingProgramsCommitTypes.PUSH_TPS,
    };
  },
  replaceTrainingProgram(trainingProgram) {
    return {
      trainingProgram,
      type: trainingProgramsCommitTypes.REPLACE_TP,
    };
  },
  replaceTrainingPrograms(list) {
    return {
      list,
      type: trainingProgramsCommitTypes.REPLACE_TPS,
    };
  },
  reviseTrainingProgram(trainingProgramGuid) {
    return async (dispatch) => {
      dispatch(this.setIsLoading('reviseTrainingProgram'));
      const data = await ApiService.post(`/api/v1/training-programs/${trainingProgramGuid}/draft`)
        .then(response => response.data)
        .catch((error) => {
          Promise.resolve();
          dispatch(commonActionCreators.handleApiError(error));
        });
      dispatch(this.setIsLoading('reviseTrainingProgram'));
      if (data) {
        dispatch(this.reviseTrainingProgramSuccess(data));
      }
      return Promise.resolve(data.data.guid);
    };
  },
  reviseTrainingProgramSuccess(revisedTrainingProgramResponse) {
    return async (dispatch) => {
      dispatch(this.pushTrainingProgram(revisedTrainingProgramResponse.data));
      dispatch(notificationsActionsCreator.addSavedSuccessfully('Training program revised'))
    };
  },
  setIsEditingTP(isEditingTP) {
    return {
      isEditingTP,
      type: trainingProgramsCommitTypes.SET_IS_EDITING_TP,
    };
  },
  setIsLoading(isLoading) {
    return {
      isLoading,
      type: trainingProgramsCommitTypes.SET_TP_IS_LOADING,
    };
  },
  setSelectedTrainingProgramGuid(selectedTPGuid) {
    return {
      selectedTPGuid,
      type: trainingProgramsCommitTypes.SET_SELECTED_TP_GUID,
    };
  },
  updateTP(tPGuid, formData) {
    return async (dispatch) => {
      dispatch(this.setIsLoading('updateTP'));
      const data = await ApiService.patch(`/api/v1/training-programs/${tPGuid}`, formData)
        .then(response => response.data)
        .catch((error) => {
          dispatch(commonActionCreators.handleApiError(error));
          return Promise.resolve();
        });
      dispatch(this.setIsLoading('updateTP'));
      if (data) {
        dispatch(this.updateTPSuccess(data));
      }
      return Promise.resolve();
    };
  },
  updateTPSuccess(updated) {
    return (dispatch) => {
      dispatch(this.replaceTrainingProgram(updated.data));
      dispatch(this.closeEditTP());
      dispatch(notificationsActionsCreator.addSavedSuccessfully('Training program updated'))
    };
  },
};

export default trainingProgramsActionCreators;
